export const CHIP = {
  "Chip.Bg.Color": {
    ref: "Color.Gray.300"
  },
  "Chip.Color": {
    ref: "Input.Color"
  },
  "Chip.Icon.Color": {
    ref: "Color.Gray.700"
  }
};
